import React from 'react';
import ModernHeader from './modern_header';
import { GlobalToastProvider } from './modern_toast';

function ModernLayout({ children, title, showFilters = false, showBackButton = false, className = '' }) {
  return (
    <GlobalToastProvider>
      <div className={`modern-layout ${className}`}>
        {/* Header moderno */}
        <ModernHeader />
        
        {/* Breadcrumb/Título da página */}
        {(title || showBackButton) && (
          <div className="modern-page-header">
            <div className="container mt-4 mb-3">
              <div className="row align-items-center">
                <div className="col">
                  {showBackButton && (
                    <button 
                      className="btn btn-link p-0 me-3 text-decoration-none"
                      onClick={() => window.history.back()}
                      aria-label="Voltar"
                    >
                      <i className="bi bi-arrow-left fs-4"></i>
                    </button>
                  )}
                  {title && (
                    <h1 className="h3 fw-bold mb-0 d-inline">{title}</h1>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Conteúdo principal */}
        <main className="modern-main">
          {children}
        </main>

        {/* Rodapé moderno (se necessário) */}
        <footer className="modern-footer mt-5">
          <div className="container py-4">
            <div className="text-center text-muted">
              <small>© 2025 Catálogo Digital</small>
            </div>
          </div>
        </footer>
      </div>
    </GlobalToastProvider>
  );
}

export default ModernLayout;
